import { Injectable } from '@angular/core';
import { GlobalFilterService } from '@shared-lib/shared-services/global-filter-service';

@Injectable({
  providedIn: 'root',
})
export class CustomGlobalFilterService extends GlobalFilterService {
  /**
   * Overrides updateFilterSelection to handle 'values' being a string instead of an array.
   * All other methods are inherited from GlobalFilterService.
   */
  override updateFilterSelection(
    keyOrKeys: string | string[],
    values: any[] | any, // Allow non-array inputs
    isQueryParam = false,
    widgetId?: string,
    emit: boolean = true,
    filterListener?: string,
    listenerExtraParams?: { [widgetId: string]: { [key: string]: any } },
  ): void {
    const keys = Array.isArray(keyOrKeys)
      ? keyOrKeys
      : (keyOrKeys || '')
          .split(',')
          .map((k) => k.trim())
          .filter((k) => k);

    keys.forEach((key) => {
      // CUSTOM CHANGE: Check if values is array. If not, use it directly.
      const valueToStore = Array.isArray(values) ? values?.[0] || null : values;

      this.selectedFilters[key] = valueToStore;

      if (isQueryParam) {
        this.filters.queryParams[key] = values;
      } else {
        this.filters.requestParams[key] = values;
      }
    });

    this.widgetId = widgetId || null;
    if (emit) {
      const filterData = {
        ...this.filters,
        widgetId: this.widgetId,
        changedFilterKey: keys.length === 1 ? keys[0] : keys,
        filterListener,
        ...(listenerExtraParams ? { listenerExtraParams } : {}),
      };

      this.filterSubject.next(filterData);
      this.currentSelectedFilter.next({ key: keys });
    }
  }
}
